<template>
    <div class="career-card">

        <button class="career-open-btn" @click="show">
            <slot name="summary"></slot>
        </button>

        <transition name="fade">
            <div v-show="showDetails" class="force-fit">
				<div class="career-overlay" @click="hide"></div>
                <button class="career-close-btn" @click="hide">
                    <icon-x />
                </button>
                <slot name="detail"></slot>

            </div>
        </transition>

    </div>
</template>

<script>
	import IconX from './Icons/IconX';

    export default {
		name: "Career",

		components: {
			IconX,
		},

        data() {
            return {
                showDetails: false,
            };
        },

        methods: {
            show() {
                this.showDetails = true;
            },

            hide() {
                this.showDetails = false;
            }
        },
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
